import { OwlModule } from "ngx-owl-carousel";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "src/app/shared/shared.module";
import { DatabaseHostingComponent } from "./database-hosting.component";
import { DatabaseOptionComponent } from './database-option/database-option.component';
import { BusinessComponent } from './business/business.component';
const routes: Routes = [
    { path: '', component: DatabaseHostingComponent }
  ];
@NgModule({
    declarations: [
        DatabaseHostingComponent,
        DatabaseOptionComponent,
        BusinessComponent
    ],
    imports: [
        HttpClientModule,
        CommonModule,
        OwlModule,
        RouterModule,
        SharedModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        RouterModule.forChild(routes)

    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports: [
        DatabaseHostingComponent
      ]
  })
  export class DatabaseHostingModule { }
  export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }